<!-- <h2 mat-dialog-title class="fw-bold mb-4">Choose Grade</h2> -->
<h2 mat-dialog-title class="fw-bold mb-4">Add Location</h2>
<h2 mat-dialog-title class="fw-bold mb-4">Add Material</h2>
<mat-dialog-content class="mat-typography buying-bales-counter-section">
    <div>
        <!-- <div class="card-header">
            <h2 class="card-title mb-4">No. of Tobacco Bales</h2>
        </div> -->
        <div class="card-body">
            <div class="">
                <!-- <form>
                <div class="custom-input-wrap">
                    <mat-label class="label">PTB Buying Grade</mat-label>
                    <mat-form-field class="custom-input" appearance="outline">
                      <input matInput placeholder="GR" formControlName="ptbGrade">
                    </mat-form-field>
                  </div>

                  <div class="custom-input-wrap">
                    <mat-label class="label">PMI Internal Grade</mat-label>
                    <mat-form-field class="custom-input" appearance="outline">
                      <input matInput placeholder="HYT" formControlName="pmiGrade">
                    </mat-form-field>
                  </div>
                </form> -->

                <!-- <form class="glap-middle-form">
                    <div class="form-fields">

                      <div class="custom-input-wrap">
                        <mat-label class="label">Location Name</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="Charbagh">Charbagh</mat-option>
                            <mat-option value="Chichawatni">Chichawatni</mat-option>
                            <mat-option value="Chilas">Chilas</mat-option>
                            <mat-option value="Cholistan">Cholistan</mat-option>
                            <mat-option value="Chabahar">Chabahar</mat-option>
                            <mat-option value="Chakri">Chakri</mat-option>
                            <mat-option value="Charos">Charos</mat-option>
                            <mat-option value="Chakdara">Chakdara</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Village Name</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="Lahore-Kaly">Lahore Kaly</mat-option>
                            <mat-option value="Lahore-Cantt">Lahore Cantt</mat-option>
                            <mat-option value="Lahore-New">Lahore New</mat-option>
                            <mat-option value="Lahore-East">Lahore East</mat-option>
                            <mat-option value="Lahore-West">Lahore West</mat-option>
                            <mat-option value="Lahore-South">Lahore South</mat-option>
                            <mat-option value="Lahore-North">Lahore North</mat-option>
                            <mat-option value="Lahore-Gora">Lahore Gora</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Sector Name</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="Shakoor">Shakoor</mat-option>
                            <mat-option value="Shahrukh">Shahrukh</mat-option>
                            <mat-option value="Shehroz">Shehroz</mat-option>
                            <mat-option value="Shah Wali">Shah Wali</mat-option>
                            <mat-option value="Shazain">Shazain</mat-option>
                            <mat-option value="Shahzeb">Shahzeb</mat-option>
                            <mat-option value="Shakir">Shakir</mat-option>
                            <mat-option value="Shah Farman">Shah Farman</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Location Code</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <input matInput placeholder="28" formControlName="username">
                        </mat-form-field>
                      </div>



                    </div>
                  </form> -->

                  <form class="glap-middle-form">
                    <div class="form-fields">

                      <div class="custom-input-wrap">
                        <mat-label class="label">Material Group</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="ClipSticks">ClipSticks</mat-option>
                            <mat-option value="CPA">CPA</mat-option>
                            <mat-option value="CPA2">CPA2</mat-option>
                            <mat-option value="Fertilizers">Fertilizers</mat-option>
                            <mat-option value="FuelWood">Fuel Wood</mat-option>
                            <mat-option value="Mechanization">Mechanization</mat-option>
                            <mat-option value="PPEs">PPEs</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Material Name</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="ClipSticks">Clip Sticks</mat-option>
                            <mat-option value="Bifinthrin">Bifinthrin (500ml)</mat-option>
                            <mat-option value="Flumetralin">Flumetralin (500 ml)</mat-option>
                            <mat-option value="NPK">NPK</mat-option>
                            <mat-option value="FuelWood">Fuel Wood</mat-option>
                            <mat-option value="Intercultivator">Intercultivator</mat-option>
                            <mat-option value="cpaGloves">CPA Gloves</mat-option>
                            <mat-option value="emamectinBenzoate">Emamectin Benzoate</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Sector Name</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <mat-select placeholder="Select" required>
                            <mat-option value="Shakoor">Shakoor</mat-option>
                            <mat-option value="Shahrukh">Shahrukh</mat-option>
                            <mat-option value="Shehroz">Shehroz</mat-option>
                            <mat-option value="Shah Wali">Shah Wali</mat-option>
                            <mat-option value="Shazain">Shazain</mat-option>
                            <mat-option value="Shahzeb">Shahzeb</mat-option>
                            <mat-option value="Shakir">Shakir</mat-option>
                            <mat-option value="Shah Farman">Shah Farman</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" class="icons-font-size">keyboard_arrow_down</mat-icon>
                        </mat-form-field>
                      </div>

                      <div class="custom-input-wrap">
                        <mat-label class="label">Location Code</mat-label>
                        <mat-form-field class="custom-input" appearance="outline">
                          <input matInput placeholder="28" formControlName="username">
                        </mat-form-field>
                      </div>



                    </div>
                  </form>

            </div>
        </div>
    </div>

</mat-dialog-content>


<mat-dialog-actions align="center" class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center mt-auto mb-auto">
    <button mat-stroked-button mat-dialog-close class="g-btn g-tertiary-btn">Cancel</button>
    <button mat-flat-button class="g-btn g-primary-btn">Save</button>
    <!-- <button mat-flat-button class="g-btn g-primary-btn">Add Grade</button> -->
</mat-dialog-actions>




<!-- <h2 mat-dialog-title class="fw-bold mb-4">Add Tobacco Type</h2>
<mat-dialog-content class="mat-typography buying-bales-counter-section">
    <div>
        <div class="card-header">
            <h2 class="card-title mb-4">No. of Tobacco Bales</h2>
        </div>
        <div class="card-body">
            <div class="">
                <form>
                <div class="custom-input-wrap">
                    <mat-label class="label">Enter Tobacco Type</mat-label>
                    <mat-form-field class="custom-input" appearance="outline">
                      <input matInput placeholder="Pipe Tobacco" formControlName="tobaccoType">
                    </mat-form-field>
                  </div>


                </form>

            </div>
        </div>
    </div>

</mat-dialog-content>


<mat-dialog-actions align="center" class="action-buttons-wrapper align-content-center align-items-center d-flex gap-4 justify-content-center mt-auto mb-auto">
    <button mat-stroked-button mat-dialog-close class="g-btn g-tertiary-btn">Cancel</button>
    <button mat-flat-button class="g-btn g-primary-btn">Add Type</button>
</mat-dialog-actions> -->
